// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shared-node[data-v-7f7b7e72] {\n  width: 100%;\n  padding: 20px;\n}", ""]);
// Exports
module.exports = exports;
